export const isNumber = e => {
  return typeof e === 'number' && !isNaN(e)
}

export const DEFAULT_THEME = 'circle-color'

export const SOCIAL_LIST = [
  // {
  //   type: 'custom',
  //   name: 'Skype',
  //   image: {
  //     prefix: 'https://www.skype.com/',
  //     alt: 'Skype',
  //     src:
  //       'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/skype@2x.png',
  //     title: 'Skype',
  //     href: 'https://www.skype.com/'
  //   },
  //   text: ''
  // },
  // {
  //   type: 'custom',
  //   name: 'Iconset',
  //   image: {
  //     prefix: 'https://www.iconset.com/',
  //     alt: 'Iconset',
  //     src:
  //       'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/iconset@2x.png',
  //     title: 'Iconset',
  //     href: 'https://www.iconset.com/'
  //   },
  //   text: ''
  // },
  // {
  //   type: 'custom',
  //   name: 'Foursquare',
  //   image: {
  //     prefix: 'https://www.foursquare.com/',
  //     alt: 'Foursquare',
  //     src:
  //       'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/foursquare@2x.png',
  //     title: 'Foursquare',
  //     href: 'https://www.foursquare.com/'
  //   },
  //   text: ''
  // },
  // {
  //   type: 'custom',
  //   name: 'Dribbble',
  //   image: {
  //     prefix: 'https://www.dribbble.com/',
  //     alt: 'Dribbble',
  //     src:
  //       'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/dribbble@2x.png',
  //     title: 'Dribbble',
  //     href: 'https://www.dribbble.com/'
  //   },
  //   text: ''
  // },
  // {
  //   type: 'custom',
  //   name: 'Behance',
  //   image: {
  //     prefix: 'https://www.behance.com/',
  //     alt: 'Behance',
  //     src:
  //       'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/behance@2x.png',
  //     title: 'Behance',
  //     href: 'https://www.behance.com/'
  //   },
  //   text: ''
  // },
  // {
  //   type: 'custom',
  //   name: 'Googleplus',
  //   image: {
  //     prefix: 'https://www.googleplus.com/',
  //     alt: 'Googleplus',
  //     src:
  //       'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/googleplus@2x.png',
  //     title: 'Googleplus',
  //     href: 'https://www.googleplus.com/'
  //   },
  //   text: ''
  // },
  {
    type: 'custom',
    name: 'Qzone',
    image: {
      prefix: 'https://www.qzone.com/',
      alt: 'Qzone',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/qzone@2x.png',
      title: 'Qzone',
      href: 'https://www.qzone.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Blogger',
    image: {
      prefix: 'https://www.blogger.com/',
      alt: 'Blogger',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/blogger@2x.png',
      title: 'Blogger',
      href: 'https://www.blogger.com/follow-blog.g?blogID='
    },
    text: ''
  },

  {
    type: 'custom',
    name: 'Facebook',
    image: {
      prefix: 'https://www.facebook.com/',
      alt: 'Facebook',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/facebook@2x.png',
      title: 'Facebook',
      href: 'https://www.facebook.com/'
    },
    text: ''
  },

  {
    type: 'custom',
    name: 'Glassdoor',
    image: {
      prefix: 'https://www.glassdoor.com',
      alt: 'Glassdoor',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/glassdoor@2x.png',
      title: 'Glassdoor',
      href: 'https://www.glassdoor.com/'
    },
    text: ''
  },

  {
    type: 'custom',
    name: 'Instagram',
    image: {
      prefix: 'https://instagram.com/',
      alt: 'Instagram',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/instagram@2x.png',
      title: 'Instagram',
      href: 'https://instagram.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Linkedin',
    image: {
      prefix: 'https://www.linkedin.com/',
      alt: 'Linkedin',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/linkedin@2x.png',
      title: 'Linkedin',
      href: 'https://www.linkedin.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Mail',
    image: {
      prefix: '',
      alt: 'Mail',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/mail@2x.png',
      title: 'Mail',
      href: ''
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Medium',
    image: {
      prefix: 'https://medium.com',
      alt: 'Medium',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/medium@2x.png',
      title: 'Medium',
      href: 'https://medium.com'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Odnoklassniki',
    image: {
      prefix: 'https://ok.ru',
      alt: 'Odnoklassniki',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/odnoklassniki@2x.png',
      title: 'Odnoklassniki',
      href: 'https://ok.ru'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Pinterest',
    image: {
      prefix: 'https://www.pinterest.com/',
      alt: 'Pinterest',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/pinterest@2x.png',
      title: 'Pinterest',
      href: 'https://www.pinterest.com/'
    },
    text: ''
  },

  {
    type: 'custom',
    name: 'SinaWeibo',
    image: {
      prefix: 'http://www.weibo.com',
      alt: 'Sina-weibo',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/sina-weibo@2x.png',
      title: 'SinaWeibo',
      href: 'http://www.weibo.com'
    },
    text: ''
  },

  {
    type: 'custom',
    name: 'Snapchat',
    image: {
      prefix: 'https://www.snapchat.com',
      alt: 'Snapchat',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/snapchat@2x.png',
      title: 'Snapchat',
      href: 'https://www.snapchat.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'SoundCloud',
    image: {
      prefix: 'https://soundcloud.com',
      alt: 'Soundcloud',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/soundcloud@2x.png',
      title: 'SoundCloud',
      href: 'https://soundcloud.com'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Spotify',
    image: {
      prefix: 'https://open.spotify.com/track',
      alt: 'Spotify',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/spotify@2x.png',
      title: 'Spotify',
      href: 'https://open.spotify.com/track'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Telegram',
    image: {
      prefix: 'https://telegram.org',
      alt: 'Telegram',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/telegram@2x.png',
      title: 'Telegram',
      href: 'https://telegram.org'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'TikTok',
    image: {
      prefix: 'https://www.tiktok.com',
      alt: 'Tiktok',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/tiktok@2x.png',
      title: 'Tiktok',
      href: 'https://www.tiktok.com'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Tripadvisor',
    image: {
      prefix: 'https://www.tripadvisor.com',
      alt: 'Tripadvisor',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/tripadvisor@2x.png',
      title: 'Tripadvisor',
      href: 'https://www.tripadvisor.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Tumblr',
    image: {
      prefix: 'https://www.tumblr.com/',
      alt: 'Tumblr',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/tumblr@2x.png',
      title: 'Tumblr',
      href: 'https://www.tumblr.com/follow/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Twitter',
    image: {
      prefix: 'https://twitter.com/',
      alt: 'Twitter',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/twitter@2x.png',
      title: 'Twitter',
      href: 'https://twitter.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Vimeo',
    image: {
      prefix: 'https://vimeo.com',
      alt: 'Vimeo',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/vimeo@2x.png',
      title: 'Vimeo',
      href: 'https://vimeo.com'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Vine',
    image: {
      prefix: 'https://vine.co',
      alt: 'Vine',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/vine@2x.png',
      title: 'Vine',
      href: 'https://vine.co'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Vkontakte',
    image: {
      prefix: 'https://vk.com',
      alt: 'Vkontakte',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/vkontakte@2x.png',
      title: 'Vkontakte',
      href: 'https://vk.com'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Website',
    image: {
      prefix: '',
      alt: 'Website',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/website@2x.png',
      title: 'Website',
      href: ''
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Wechat',
    image: {
      prefix: 'https://www.wechat.com',
      alt: 'Wechat',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/wechat@2x.png',
      title: 'Wechat',
      href: 'https://www.wechat.com'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Whatsapp',
    image: {
      prefix: 'https://www.whatsapp.com',
      alt: 'Whatsapp',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/whatsapp@2x.png',
      title: 'Whatsapp',
      href: 'https://www.whatsapp.com/'
    },
    text: ''
  },
  {
    type: 'custom',
    name: 'Youtube',
    image: {
      prefix: 'https://www.youtube.com/',
      alt: 'Youtube',
      src:
        'https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/@@@replace@@@/youtube@2x.png',
      title: 'Youtube',
      href: 'https://www.youtube.com/'
    },
    text: ''
  }
]

export const socialOptions = SOCIAL_LIST.map(e => e.name)
  .sort()
  .map(e => ({
    label: e,
    value: e
  }))
